<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          選択商品一覧
        </v-card-title>

        <v-data-table :headers="itemHeaders" :items="dispSelectedItems" class="elevation-1" hide-actions :loading="loadingData" >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.itemCategoryName }}</td>
              <td class="text-xs-left">{{ props.item.itemName }}</td>
              <td class="text-xs-left">{{ props.item.janCode }}</td>
              <td class="text-xs-left">{{ props.item.unitPrice }}</td>
            </tr>
          </template>         
        </v-data-table>

        <div style="height: 55px;"></div>
      </v-container>
    </v-card>

    <div style="height: 55px;"></div>
    <v-card>
      <v-container>
        <v-card-title class="title-highlight">
          店舗一覧
        </v-card-title>

        <!-- 점포 검색조건 -->
        <v-layout row span justify-space-between>
          <v-flex xs12>
            <v-select
              v-model="selectSupplier"
              :items="suppliers"
              label="取引先選択"
              item-text="supplierName"
              item-value="supplierCode"
              :sort-by="['supplierCode']"
              :sort-desc="[false]"              
              return-object
            ></v-select>
          </v-flex>
        </v-layout>

        <div style="
          white-space: pre-line;
          margin-bottom: 10px;
          text-align: left;
        ">※当該店舗に登録されている商品を表示する。
        </div>

        <!-- 전체선택 -->
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <v-checkbox
            v-model="allSelected"
            @change="toggleAll"
            hide-details
            primary
            dense
            label="全選択/解除"
            class="same-font"
          ></v-checkbox>
        </div>

        <!-- 점포 데이타 -->
        <v-data-table :headers="headers" :items="stores" class="elevation-1" hide-actions :custom-filter="customFilter" :search="selectSupplier">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left" style="width: 30px;" @click="storeCheck(props.item)">
                <v-checkbox v-model="props.item.isHandling" primary hide-details></v-checkbox>
              </td>
              <td class="text-xs-left">{{ props.item.storeCode }}</td>
              <td class="text-xs-left">{{ props.item.storeName }}</td>
              <td class="text-xs-left">{{ props.item.supplierCode }}</td>
            </tr>
          </template>
        </v-data-table>
        <div style="height: 25px;"></div>

        <!-- 버튼 영역 -->
        <div class="footer-btns">
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/store-item-list' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
          <v-btn block color="error" dark @click="deleteStoreItems()">
            <v-icon dark left>save</v-icon>取扱商品を削除する
          </v-btn>       
        </div>
        <div style="height: 25px;"></div>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
// import { fileURLToPath } from 'url'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this

    // 세션에서 상품정보 가져오기
    const params = JSON.parse(sessionStorage.getItem("param"));
    for (let i=0; i<params.length; i++) {
      thisObj.dispSelectedItems.push(params[i]);
    }

    // 모든 거래처정보 가져오기
    ServerApiCallService.suppliers()
      .then(response => {
        thisObj.suppliers = response.data.suppliers

        // 사용하는 점포 항목추가
        thisObj.suppliers.unshift({
          supplierCode: '#',
          supplierName: '全て(使える店舗)'
        })

        // 삭제점포 항목추가
        thisObj.suppliers.splice(1,0,{
          supplierCode: 'r',
          supplierName: '使えない店舗'
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      }
    )

    // 해당 상품을 가지고 있는 모든 점포정보 가져오기
    // 1나이상의 상품중에 1나만 가지고 있는 점포도 포함
    ServerApiCallService.storesWithItems(thisObj.dispSelectedItems)
      .then(response => {
        thisObj.stores = response.data.stores

        thisObj.loadingData = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      }
    )
  },
  methods: {
    // 전체선택,해제 UI용 기능
    toggleAll() {
      let checked = this.allSelected;

      // 화면에 보이는 상품만 처리
      this.stores.forEach(store => {
        store.isChecked = checked;
        store.isHandling = checked;
      });

      // selectedStores 동기화: 잠금된 기존 등록은 항상 포함 + 신규 선택만 반영
      const newly = checked ? this.stores : [];
      this.selectedStores = [...newly];
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.supplierCode < b.supplierCode) {
          return -1
        } else if (a.supplierCode > b.supplierCode) {
          return 1
        }
        if (a.storeName < b.storeName) {
          return -1
        } else if (a.storeName > b.storeName) {
          return 1
        }
        return 0
      })
      return items
    },
    customFilter(items, search) {
      console.log('customFilter called');

      if (search.supplierName === '全て(使える店舗)') {
        // 사용하는 점포만 보여주기
        let activeStores = items.filter(function(value) {
            return true;
        })        

        return this.customSort(activeStores)
      } else if (search.supplierName === '使えない店舗') {
        // 사용하지 않는 점포만 보여주기
        let inactiveStores = items.filter(function(value) {
            return false;
        })

        return this.customSort(inactiveStores)
      } else {
        let filteringItems = items.filter(function(value) {
          // 선택된 거래처의 사용하는 점포만 보여주기
          if (value.supplierCode === search.supplierCode) {
            return true
          } else {
            return false
          }
        })        

        return this.customSort(filteringItems)
      }
    }, 
    storeCheck(storeInfo) {
      let thisObj = this
      thisObj.loading2 = false

      if (storeInfo.isChecked) {
        storeInfo.isChecked = false

        // 체크를 지웠을때 
        for(let i = 0; i < thisObj.selectedStores.length; i++) {
          if(thisObj.selectedStores[i].storeCode === storeInfo.storeCode)  {
            thisObj.selectedStores.splice(i, 1);
            if (i > 0) i--;
          }
        }
      } else {
        // 체크를 했을때
        storeInfo.isChecked= true;
        thisObj.selectedStores.push(storeInfo);
      }
    },
    async deleteStoreItems() {
      let thisObj = this
      thisObj.loading2 = true

      // 점포를 선택하지 않았을때
      if (thisObj.selectedStores.length < 1) {
        this.$parent.$parent.$parent.showErrorDialog(
          '店舗を選択してください'
        )
        return;
      }

      if (!confirm("チェックした店舗から商品を削除します\nよろしいですか")) {
        return;
      }
      
      let request = [];
      for (let i=0; i<thisObj.selectedStores.length; i++) {
        let selectedStore = thisObj.selectedStores[i];

        // 선택된 복수의 점포를 수정해서 재 보관
        let selectedShopsItems = [];
        this.dispSelectedItems.forEach((dispItem) => {
          delete dispItem.isChecked
          selectedShopsItems.push(dispItem)
        })
        
        let obj = {
          storeCode: selectedStore.storeCode,
          shopsItems: selectedShopsItems
        }

        request.push(obj);
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent,
        forwardNameOnClose: 'admin/store-item-list'
      }
      
      // 점포에 상품을 삭제
      ServerApiCallService.storesItemsMultiDelete(
          request,
          sendContext
        ).then(() => {
          this.loading2 = false
        }).catch(error => {
          console.log('There was an error:', error.response)
        })
    },    
  },
  data() {
    return {
      loadingData: false,
      isHandling: true,
      loading: true,
      loading1: false,
      loading2: false,
      handlingItem: false,
      checkbox: null,
      allSelected: false,

      name: '',
      storeName: '',      
      selectedStoreCode: '',
      isDeleted: '0',

      storeCode: this.$route.params.storeCode,

      stores: [],
      selected: [],
      handlingItemsByStore: [],      
      itemCategories: [],
      shopsItems: [],
      dispShopsItemsIDs: [],
      dispSelectedItems: [], // 선택된 상품
      allStores: [], // 모든 점포
      selectedStores: [], // 선택된 점포

      suppliers: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て(使える店舗)'
      },

      multipleSearchObj: {
        itemCategoryId: '#',
        dispOnlyHandling: false
      },

      headers: [
        {
          text: '選択',
          align: 'left',
          sortable: false,
          value: 'selectSupplier',
          width: '50px',
          fixed: true
        },
        {
          text: '店舗コード',
          align: 'left',
          sortable: false,
          value: 'storeCode',
          width: '200px',
          fixed: true
        },
        {
          text: '店舗名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '250px',
          fixed: true
        },
        {
          text: '取引先コード',
          align: 'left',
          sortable: false,
          value: 'supplierCode',
          width: '100px'
        },
      ],
      itemHeaders: [
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
      ],
    }
  }
}
</script>

<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>